import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '@shared-library';
import { FdkButtonComponent, FdkCheckboxComponent, FdkIllustrationComponent, FdkLinkComponent, FdkSpinnerComponent, FdkIconComponent } from 'fasten-design-kit';

import {VaultProfileSigninFlowService} from '../../services/vault-profile-signin-flow.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css'],
  standalone: true,
  imports: [CommonModule, FdkSpinnerComponent, FdkButtonComponent, FdkCheckboxComponent, FdkIllustrationComponent, FdkLinkComponent, FdkIconComponent],
})
export class WelcomeComponent implements OnInit {
  loading = false;
  errorMsg = '';
  storageAccessConsentChecked = false;

  readonly needStorageAccessPermissionSubject = this.signinFlowService.needStorageAccessPermissionSubject;

  constructor(
    public configService: ConfigService,
    public signinFlowService: VaultProfileSigninFlowService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.signinFlowService.initializeStorageAccess();
  }

  onStorageAccessConsentChange(event: Event): void {
    this.storageAccessConsentChecked = (event.target as HTMLInputElement).checked;

    if (this.storageAccessConsentChecked) {
      this.signinFlowService.awaitUserInteractionCompleted();
    }
  }

  continue(): void {
    this.loading = true;
    this.errorMsg = '';

    const storageAccessPromise = this.signinFlowService.requiresStorageAccess()
      ? this.signinFlowService.requestStorageAccess()
      : Promise.resolve(true);

    storageAccessPromise
      .then(() => {
        this.signinFlowService.completeWelcome();
        return this.router.navigate(['/auth/signin/email'], {queryParamsHandling: 'preserve'});
      })
      .catch((error) => {
        this.errorMsg = error?.message || 'Storage access is required to continue.';
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
